import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { NavLink } from "react-router-dom";

const Tab = ({ children, href }) => {
  return (
    <TabWrapper hasHref={href}>
      {href ? <NavLink to={href}>{children}</NavLink> : children}
    </TabWrapper>
  );
}

export default Tab;

Tab.propTypes = {
  href: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string
  ]).isRequired
}

const tabActiveMixin = css`
  color: var(--lizzy-blue);
  font-weight: 600;

  &::before {
    position: absolute;
    content: '';
    width: 100%;
    border-bottom: 4px var(--lizzy-blue) solid;
    bottom: 0;
    left: 0;
  }
`

const TabWrapper = styled.li`
  position: relative;
  font-size: 20px;
  padding: 40px;

  & > a {
    text-decoration: none;

    &.active {
      ${tabActiveMixin}
    }
  }
`;